import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import { prepareNativeLabOrderSet } from '@lotushealth/lotushealth_js_sdk/endpoints';
import type {
  PrepareNativeLabOrderSetRequestT,
  PrepareNativeLabOrderSetResponseT,
} from '@lotushealth/lotushealth_js_sdk/schemas';
import { isAxiosError } from 'axios';

import { extractApiErrorDetail } from '@/shared';
import { createLotusRequestConfig } from '@/shared/api/lotus';

export type { PrepareNativeLabOrderSetRequestT, PrepareNativeLabOrderSetResponseT };

export type PrepareNativeLabOrderSetResultT =
  | { type: 'success'; preparation: PrepareNativeLabOrderSetResponseT }
  | { type: 'failure'; details: string };

export async function fetchPrepareNativeLabOrderSet(
  request: PrepareNativeLabOrderSetRequestT,
  signal?: AbortSignal
): Promise<PrepareNativeLabOrderSetResultT> {
  try {
    const config = await createLotusRequestConfig({ signal });
    const response = await prepareNativeLabOrderSet(request, config);
    return {
      type: 'success',
      preparation: lotusHealthZod.prepareNativeLabOrderSetResponse.parse(response.data),
    };
  } catch (error: unknown) {
    if (!isAxiosError(error) || error.response?.status !== 422) {
      throw error;
    }
    return {
      type: 'failure',
      details:
        extractApiErrorDetail(error) ?? 'The selected labs could not be prepared for ordering.',
    };
  }
}
